<template>

    <timeregistration-totals
        :show-finances="canViewFinances"
    ></timeregistration-totals>

</template>

<script>

import { mapGetters } from 'vuex';
import Lang from '../../Lang';
import TimeregistrationTotals from "../../components/Projects/TimeregistrationTotals";

export default {

    components: {
        TimeregistrationTotals,
    },

    computed: {
        ...mapGetters([
            'getProject',
            'hasLicense',
        ]),

        canViewFinances() {
            return this.hasLicense('finance');
        },

        project() {
            return this.getProject;
        },
    },

    metaInfo: {
        title:Lang.get('hr.index') + ' - ' + Lang.get('projects.tabs.hourstotals'),
    },

    name:'ProjectsDetailsHourTotals',

}

</script>
